export enum SocialProvider {
  google = "google",
  gitlab = "gitlab",
  github = "github",
}

export enum SocialButtonColor {
  white = "ffffff",
  blue = "1877F2",
  black = "000000",
}
